import React, { useState, useEffect } from 'react';
import styles from '../../src/assets/scss/design.scss';
import { useLocation } from 'react-router-dom';
import Lottie from 'react-lottie';
import { verifyEmail } from '../../src/services/profile';
import star from '../../src/assets/images/stars.json';
import { Helmet } from 'react-helmet';
import { finishTimeTracker, initTimeTracker } from '../../src/utilities/timeTracker';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: star,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EmailConfirmation() {
  const [message, setMessage] = useState('');
  const query = useQuery();

  useEffect(() => {
    const confirmationToken = query.get('token');
    if (confirmationToken) {
      emailVerification(confirmationToken);
    }
    initTimeTracker('Others');
    return () => {
      const ttdata = JSON.parse(localStorage.getItem('ttdata'));
      if (ttdata && ttdata.product === 'Others') {
        finishTimeTracker(ttdata && ttdata.trackerId);
      }
    };
  }, []);

  const emailVerification = (token) => {
    verifyEmail(token)
      .then((response) => {
        console.log(response);
        setMessage(response.message);
      })
      .catch((error) => {
        console.log(error.response);
        setMessage(error.response.data.message);
      });
  };

  return (
    <div className={styles.email_verify}>
      <Helmet>
        <title>User Email Confirmation</title>
      </Helmet>
      <Lottie options={defaultOptions} width={250} height='50%' />
      <div className={styles.email_verify_message}>{message}</div>
    </div>
  );
}

export default EmailConfirmation;
